export const SEARCH_COMMUNITY = 'SEARCH_COMMUNITY'
export const SEARCH_COMMUNITY_RESULT = 'SEARCH_COMMUNITY_RESULT'
export const SEARCH_COMMUNITY_RESULT_REMOVE = 'SEARCH_COMMUNITY_RESULT_REMOVE'


// WEBPACK FOOTER //
// ./src/constants/Search.js